import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import { ShareLinkDialog } from '@playbookux/playbook-web-core'; import { UPDATE_HIGHLIGHT_REEL_SHARE_LINK } from '../graphql';
import { config } from '../../../../config';

const ShareHighlightReelDialog = (props) => {
  const {
    highlightReel,
    companyId,
    show,
    handleClose,
  } = props;
  const {
    id,
    title,
    sharePassword,
    shareEnabled,
    shareCode,
  } = highlightReel;
  const uri = `${config.REACT_APP_PLATFORM_URI}/share/highlight-reel/${shareCode}`;

  const [updateHighlightReel] = useMutation(UPDATE_HIGHLIGHT_REEL_SHARE_LINK);

  const handleUpdate = (password, enableShare) => {
    updateHighlightReel({
      variables: {
        id,
        attributes: {
          companyId,
          sharePassword: password,
          shareEnabled: enableShare,
        },
      },
    });
  };

  return (
    <ShareLinkDialog
      title={`Share ${title}`}
      uri={uri}
      sharePassword={sharePassword}
      shareEnabled={shareEnabled}
      toggleLabel="Enable highlight reel sharing"
      handleUpdate={handleUpdate}
      show={show}
      handleClose={handleClose}
    />
  );
};

ShareHighlightReelDialog.propTypes = {
  shareCode: PropTypes.string,
  highlightReel: PropTypes.object.isRequired,
  companyId: PropTypes.string.isRequired,
  show: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};

ShareHighlightReelDialog.defaultProps = {
  shareCode: '',
  show: false,
};

export default ShareHighlightReelDialog;
